import React, { useState, useEffect} from 'react';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import {uploadFeedback} from '../../dbApi/DbApi'

const componyName = "FittedChoise"

const FeedbackBox = (props) => {
  const SEND =  "SEND";
  const FAIL =  "FAIL";
  const SECSSES = "SECSSES";

  const [user, setUser] = useState();
  const [content, setContent] = useState();

  const [userError, setUserError] = useState(false);
  const [contentError, setContentError] = useState(false);

  const [status, setStatus] = useState();

  const submit = async () => {
    if(!user || user.length === 0){
      setUserError(true)
      return ;
    }
    if(!content || content.length === 0){
      setContentError(true)
      return ;
    }
    setStatus(SEND);
    const response = await uploadFeedback(user, content);
    console.log("response");
    console.log(response);
    if(response.status === 201){
      setStatus(SECSSES);
    }
    else{
      setStatus(FAIL)
    }
  }

  return (
        <Paper className={"px-5"} style={{background:"aliceblue"}}>
          {(status !== SECSSES) &&
            <div>
              <TextField className={"left py-3"}
                value={user}
                id="standard-basic" label="Name"
                error={userError}
                helperText={userError?"User Cant Be Empty.":""}
                onChange={(e) => {setUser(e.target.value); setUserError(false)}} />
              <TextField
                 id="outlined-textarea"
                 label="Feedback"
                 placeholder="Write feedback here."
                 variant="outlined"
                 multiline
                 style={{width:"100%"}}
                 value={content}
                 error={contentError}
                 helperText={contentError?"Feedback Cant Be Empty.":""}
                 onChange={(e) => {setContent(e.target.value); setContentError(false)}}
               />
              <Button onClick={submit} type="submit" className={"my-2"} variant="contained" color="primary">
                  {"Send Feedback"}
              </Button>
            </div>
          }
          { (status === SECSSES) &&
              (<div style={{padding:"20px"}}>
                <h1>
                  <i class="fas fa-check-circle" style={{color:"green"}}></i>
                  {"Thank You!"}
                </h1>
              </div>)
          }
          { (status === FAIL) &&
            (<div>
              {"error"}
            </div>)
          }
        </Paper>
      );
}



export default FeedbackBox
